import classNames from 'classnames';
import { ForwardedRef } from 'react';

import ProShareIcon from '../icons/ProShareIcon';
import BasicButton, { BasicButtonElement, BasicButtonProps } from './BasicButton';

import styles from '../../styles/buttons/pro-share-button.module.css';

interface ProShareButtonProps extends BasicButtonProps {
    color?: string;
}

function ProShareButton({
    className = null,
    ref: buttonRef = null,
    ...props
}: ProShareButtonProps & { ref?: ForwardedRef<BasicButtonElement> | null }) {
    return (
        <BasicButton
            ref={buttonRef}
            className={classNames([styles.container, className])}
            {...props}
        >
            <ProShareIcon className={styles.icon} />
        </BasicButton>
    );
}

export default ProShareButton;
